import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";

const Footer = () => {
    const [footerHeight, setFooterHeight] = useState("55vh");

    useEffect(() => {
        const updateFooterHeight = () => {
            const firstSection = document.getElementById("first-section");
            if (firstSection) {
                setFooterHeight(`${firstSection.clientHeight / 2}px`);
            }
        };

        updateFooterHeight(); // Set initial height
        window.addEventListener("resize", updateFooterHeight); // Update on resize

        return () => window.removeEventListener("resize", updateFooterHeight);
    }, []);
    return (
        <Box
            component="footer"
            id="footer"
            sx={{
                width: "100%",
                height: footerHeight, // Dynamically set height
                backgroundColor: "rgba(240, 240, 240, 0.6)",
                fontFamily: "'Poppins', sans-serif",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                position: "relative",
                bottom: 0,
                padding: { xs: "0px", md: "20px 0" },
            }}
        >
            {/* Shop Section */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: { xs: "18px", md: "24px" }, // Smaller text for mobile
                    fontWeight: "bold",
                    padding: "10px 0",
                }}
            >
                {/* Empty section */}
            </Box>

            {/* Information Section */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: "bold",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: { xs: "12px", md: "16px" }, // Adjusted font size for smaller screens
                    }}
                >
                    sanaxillu
                </Typography>
                {/* <Typography
                    variant="body1"
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: { xs: "14px", md: "16px" },
                    }}
                >
                    xxx@gmail.com
                </Typography> */}

                {/* Social Media Icons */}
                <Box
                    sx={{
                        display: "flex",
                        gap: { xs: "15px", md: "30px" }, // Reduce gap between icons on mobile
                        marginTop: "10px",
                    }}
                >
                    {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                        <Facebook
                            sx={{
                                fontSize: { xs: "24px", md: "28px" }, // Smaller icons on mobile
                                color: "black",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.2)",
                                    color: "#1877F2",
                                },
                            }}
                        />
                    </a> */}
                    <a href="https://www.instagram.com/sanaxillu/" target="_blank" rel="noopener noreferrer">
                        <Instagram
                            sx={{
                                fontSize: { xs: "24px", md: "28px" }, // Smaller icons on mobile
                                color: "black",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.2)",
                                    color: "#E4405F",
                                },
                            }}
                        />
                    </a>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
